import { CoreServer } from './core-server';

/** 核心类 */
export class Core extends CoreServer {
    constructor(identity: string) {
        super(identity);
    }

    destroy() {
        super.destroy();
    }
}
